<template>
    <div>
        <div class="adaptation-block">
            <div class="adaptation-block__column">
                <div v-if="loaded">

                    <uzhnet-back-button @click="$router.push('/main')" />

                    <div class="profiles-container">
                        <div class="profile-bar">
                            <div class="profile-bar__address">{{ locale == 'en' ? transliterate(store.address_formatted) : store.address_formatted  }}</div>
                            <div class="profile-bar__login">{{ store.login }}</div>

                            <div class="profile-bar__bar">
                                <svg width="100%" height="200%" viewBox="0 0 323 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.5 7.20711L7.20711 0.5H303.725L322.5 18.2157L322.501 26.815L316.77 33.5H19.2002L0.5 15.7849V7.20711Z" stroke="#CACACA"/>
                                    <path d="M322.501 11.8534L310.274 0.5H322.501V11.8534Z" fill="#CACACA" stroke="#CACACA"/>
                                    <path d="M0.500977 22.1466L12.7277 33.5H0.500977V22.1466Z" fill="#CACACA" stroke="#CACACA"/>
                                    <path d="M301.992 17H301.983" stroke="#E0C522" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M302 23H301.991" stroke="#E0C522" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M301.985 11H301.976" stroke="#E0C522" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M296 10L280 10" stroke="#E0C522" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M296 17L280 17" stroke="#E0C522" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M296 24L280 24" stroke="#E0C522" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M15 0V29.5" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M17 0V31" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M19 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M21 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M23 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M25 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M27 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M29 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M31 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M33 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M35 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M37 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M39 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M41 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M43 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M45 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M47 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M49 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M51 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M53 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M55 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M57 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M59 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M61 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M63 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M65 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M67 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M69 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M71 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M73 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M75 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M77 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M79 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M81 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M83 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M85 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M87 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M89 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M91 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M93 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M95 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M97 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M99 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M101 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M103 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M105 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M107 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M109 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M111 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M113 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M115 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M117 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M119 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M121 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M123 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M125 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M127 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M129 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M131 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M133 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M135 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M137 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M139 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M141 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M143 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M145 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M147 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M149 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M151 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M153 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M155 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M157 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M159 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M161 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M163 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M165 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M167 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M169 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M171 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M173 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M175 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M177 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M179 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M181 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M183 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M185 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M187 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M189 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M191 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M193 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M195 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M197 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M199 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M201 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M203 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M205 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M207 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M209 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M211 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M213 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M215 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M217 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M219 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M221 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M223 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M225 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M227 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M229 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M231 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M233 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M235 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M237 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M239 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M241 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M243 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M245 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M247 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M249 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M251 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M253 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M255 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M257 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M259 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M261 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M263 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M265 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M267 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M269 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M271 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M273 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M275 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M277 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M279 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M281 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M283 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M285 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M287 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M289 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M291 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M293 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M295 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M297 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M299 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M301 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M303 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M305 1.49988V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M307 3.50024V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M309 5.50012V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M311 7.34875V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M313 9.50012V33.2342" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M315 11.4998V32.9279" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M317 13V33" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M319 15.0001V31.0001" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M321 16.4998V28.4998" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M13 0.153198V27.4999" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M11 0.459351V25.9999" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M9 0.999878V23.9999" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M7 1.0719V21.9996" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M5 2.49988V19.9999" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M3 4.99988V17.9999" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                    <path d="M1 6.49963V16.4996" stroke="#C7C8D1" stroke-opacity="0.1"/>
                                </svg>
                            </div>
                        </div>

                        <div class="header-block" style="margin-top: 30px;">
                            <div class="barrier">
                                <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M119 1H114L125 11H130L119 1Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M114 1H0" stroke="#CACACA"/>
                            </svg>
                            </div>
                            <div class="label">
                                {{ $t('profileSelectingPage.profilesHeader') }}
                            </div>
                            <div class="barrier">
                                <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 11H18L7 1H2L13 11Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M18 11H132" stroke="#CACACA"/>
                            </svg>
                            </div>
                        </div>

                        <div class="all-profiles">
                            <div v-for="profile in allProfiles" class="profile-row">
                                <div class="profile-row__content">
                                    <div class="profile-row__icon">
                                        <div class="menu-container__button">
                                            <img src="@/assets/icons/specials/profile-icon.svg" alt="">
                                        </div>
                                    </div>
                                    <div class="profile-row__data">
                                        <div>{{ profile.login }}</div>
                                        <div class="truncate">{{ locale == 'en' ? transliterate(profile.address) : profile.address}}</div>
                                    </div>
                                </div>
                                <div class="profile-row__select">
                                    <uzhnet-select :select="selectedProfileId == profile.login" @selected="selectedProfileId = profile.login"/>
                                </div>
                            </div>
                        </div>

                        <div class="confirm-block">
                            <uzhnet-button @click="selectProfile" :label="$t('profileSelectingPage.accept')" />
                        </div>
                    </div>
                </div>
                <Transition v-else name="show" appear mode="out-in">
                    <Loading />
                </Transition>
            </div>
        </div>

    </div>
</template>

<script>
import '@/assets/scss/profile-selecting-page.scss';
import { ref, onMounted } from 'vue';
import { useMainStore } from '@/store/mainStore';
import { getAccounts, getAccountByLogin } from '@/db/accountService';
import { decryptMessage } from '@/services/cryptoUtils'
import { calculateFingerprint } from '@/services/fingerprint'
import { useRouter } from 'vue-router';
import ApiManager from '@/services/ApiManager';

import Loading from '@/components/Loading.vue';

import { useI18n } from 'vue-i18n';

function transliterate(text) {
    const ukToEnMap = {
        'А': 'A', 'Б': 'B', 'В': 'V', 'Г': 'H', 'Ґ': 'G', 'Д': 'D',
        'Е': 'E', 'Є': 'Ye', 'Ж': 'Zh', 'З': 'Z', 'И': 'Y', 'І': 'I',
        'Ї': 'Yi', 'Й': 'Y', 'К': 'K', 'Л': 'L', 'М': 'M', 'Н': 'N',
        'О': 'O', 'П': 'P', 'Р': 'R', 'С': 'S', 'Т': 'T', 'У': 'U',
        'Ф': 'F', 'Х': 'Kh', 'Ц': 'Ts', 'Ч': 'Ch', 'Ш': 'Sh', 'Щ': 'Shch',
        'Ь': '', 'Ю': 'Yu', 'Я': 'Ya',
        'а': 'a', 'б': 'b', 'в': 'v', 'г': 'h', 'ґ': 'g', 'д': 'd',
        'е': 'e', 'є': 'ie', 'ж': 'zh', 'з': 'z', 'и': 'y', 'і': 'i',
        'ї': 'i', 'й': 'i', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n',
        'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u',
        'ф': 'f', 'х': 'kh', 'ц': 'ts', 'ч': 'ch', 'ш': 'sh', 'щ': 'shch',
        'ь': '\'', 'ю': 'iu', 'я': 'ia'
    };

    if (text) {
        return text.split('').map(char => ukToEnMap[char] || char).join('');
    } else {
        return text
    }
}

export default {
    name: "ProfileSelecting",

    setup() {
        const store = useMainStore();
        const router = useRouter();

        const selectedProfileId = ref(0);

        const allProfiles = ref([]);

        const loaded = ref(true);

        const { locale } = useI18n();

        onMounted(async () => {
            const allAccountsCursor = await getAccounts();
            allProfiles.value = allAccountsCursor.map(account => {
                return account._data
            })

            selectedProfileId.value = store.login
        })

        const selectProfile = async () => {
            let currentAccount = await getAccountByLogin(selectedProfileId.value)
            currentAccount = currentAccount._data

            loaded.value = false

            const fingerprint = await calculateFingerprint()

            const decryptedToken = await decryptMessage(currentAccount.token, fingerprint, currentAccount.iv)

            const response = await ApiManager.getUserInfo(decryptedToken)
            const responseData = response.data

            if (responseData.status === false) {
                router.push('/login')
                return
            } else {
                const clientInternetResponse = await ApiManager.getUserInternet(decryptedToken)
                const clientInternetData = clientInternetResponse.data

                const clientTvResponse = await ApiManager.getUserTv(decryptedToken)
                const clientTvData = clientTvResponse.data

                store.setUserData(responseData)
                store.setUserInternetData(clientInternetData)
                store.setUserTvData(clientTvData)
            }

            router.push('/main')
        }

        return {
            selectedProfileId,
            allProfiles,
            store,
            loaded,
            transliterate: transliterate,
            selectProfile,
            locale
        }
    },

    components: {
        Loading
    }
}
</script>
